import { render, staticRenderFns } from "./TrSelectImage.vue?vue&type=template&id=5a910e06&scoped=true&"
import script from "./TrSelectImage.vue?vue&type=script&lang=js&"
export * from "./TrSelectImage.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectImage.vue?vue&type=style&index=0&id=5a910e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a910e06",
  null
  
)

export default component.exports